// import React, { useState } from 'react';
// import styles from './styles.module.css';
// import Clock from '../../../../images/icons/timer.png';
// import Chef from '../../../../images/icons/chef-hat.png';
// import Serving from '../../../../images/icons/user (2).png';
// import IngredientIcon from '../../../../images/icons/harvest.png';
// import Image from 'react-bootstrap/Image';

// export default function MealDetail({ mealData, isMealInstance, onBack }) {
    
//     // const { name, prep_time, cooking_time, serving, meal_images, category, preparation, description, cooking_instructions  } = mealInstance.attributes.meal.data.attributes;
//     // const imageUrl = meal_images.data[0].attributes.image.data.attributes.url;
//     // const [activeTab, setActiveTab] = useState("description");

//     // // Beregning av næringsinnhold
//     // const calculateNutrition = () => {
//     //     let totalProtein = 0;
//     //     let totalCarbs = 0;
//     //     let totalFat = 0;
//     //     let totalKcals = 0;
    
//     //     mealInstance.attributes.custom_ingredients.forEach(ingredient => {
//     //         const { amount, unit, macros } = ingredient;
//     //         const quantity = parseFloat(amount);
    
//     //         if (unit === "stk") {
//     //             // Multipliser direkte med antall hvis enheten er "stk"
//     //             totalProtein += macros.protein * quantity;
//     //             totalCarbs += macros.carbs * quantity;
//     //             totalFat += macros.fat * quantity;
//     //             totalKcals += macros.kcals * quantity;
//     //         } else if (unit === "g") {
//     //             // Hvis enheten er gram, beregn basert på makroer per 100g
//     //             totalProtein += (macros.protein / 100) * quantity;
//     //             totalCarbs += (macros.carbs / 100) * quantity;
//     //             totalFat += (macros.fat / 100) * quantity;
//     //             totalKcals += (macros.kcals / 100) * quantity;
//     //         } else if (unit === "dl") {
//     //             // Anta at 1 dl ≈ 100g, og beregn makroene basert på dette
//     //             const gramsEquivalent = quantity * 100;
//     //             totalProtein += (macros.protein / 100) * gramsEquivalent;
//     //             totalCarbs += (macros.carbs / 100) * gramsEquivalent;
//     //             totalFat += (macros.fat / 100) * gramsEquivalent;
//     //             totalKcals += (macros.kcals / 100) * gramsEquivalent;
//     //         }
//     //     });
    
//     //     return {
//     //         totalProtein: Math.round(totalProtein),
//     //         totalCarbs: Math.round(totalCarbs),
//     //         totalFat: Math.round(totalFat),
//     //         totalKcals: Math.round(totalKcals),
//     //     };
//     // };

//     // const { totalProtein, totalCarbs, totalFat, totalKcals } = calculateNutrition();

//     const mealAttributes = isMealInstance ? mealData.attributes.meal.data.attributes : mealData.attributes;
//     const { name, prep_time, cooking_time, serving, meal_images, category, preparation, description, cooking_instructions } = mealAttributes;
//     const imageUrl = meal_images?.data[0]?.attributes?.image?.data?.attributes?.url;
//     const [activeTab, setActiveTab] = useState("description");

//     const calculateNutrition = () => {
//         let totalProtein = 0;
//         let totalCarbs = 0;
//         let totalFat = 0;
//         let totalKcals = 0;

//         const ingredients = isMealInstance
//             ? mealData.attributes.custom_ingredients
//             : mealData.attributes.meal_ingredients.data;

//         ingredients.forEach(ingredient => {
//             const { amount, unit, macros } = ingredient;
//             const quantity = parseFloat(amount);

//             if (unit === "stk") {
//                 totalProtein += macros.protein * quantity;
//                 totalCarbs += macros.carbs * quantity;
//                 totalFat += macros.fat * quantity;
//                 totalKcals += macros.kcals * quantity;
//             } else if (unit === "g") {
//                 totalProtein += (macros.protein / 100) * quantity;
//                 totalCarbs += (macros.carbs / 100) * quantity;
//                 totalFat += (macros.fat / 100) * quantity;
//                 totalKcals += (macros.kcals / 100) * quantity;
//             } else if (unit === "dl") {
//                 const gramsEquivalent = quantity * 100;
//                 totalProtein += (macros.protein / 100) * gramsEquivalent;
//                 totalCarbs += (macros.carbs / 100) * gramsEquivalent;
//                 totalFat += (macros.fat / 100) * gramsEquivalent;
//                 totalKcals += (macros.kcals / 100) * gramsEquivalent;
//             }
//         });

//         return {
//             totalProtein: Math.round(totalProtein),
//             totalCarbs: Math.round(totalCarbs),
//             totalFat: Math.round(totalFat),
//             totalKcals: Math.round(totalKcals),
//         };
//     };

//     const { totalProtein, totalCarbs, totalFat, totalKcals } = calculateNutrition();

//     return (
//         <div className={styles.detailContainer}>
//             <div className={styles.header}>
//                 <button className={styles.backButton} onClick={onBack}>Tilbake</button>
//             </div>
//             <div className={styles.name}>{name}</div>
//             <div className={styles.category}>{category}</div>
//             <div className={styles.mealImage} style={{ backgroundImage: `url(${imageUrl})` }} />
//             <div className={styles.prepInfo}>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Clock} fluid alt="clock icon" />
//                         </div>
//                         <div className={styles.prepText}>Prep:</div>
//                     </div>
//                  <p><strong>{prep_time} min</strong></p>
//                 </div>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Chef} fluid alt="chef icon" />
//                         </div>
//                         <div className={styles.prepText}>Cooking:</div>
//                     </div>
//                  <p><strong>{cooking_time} min</strong></p>
//                 </div>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Serving} fluid alt="servings icon" />
//                         </div>
//                         <div className={styles.prepText}>Serving:</div>
//                     </div>
//                  <p><strong>{serving} serving</strong></p>
//                 </div>
//             </div>
//             <div className={styles.nutritionContainer}>
//                 <h3>Næringsinnhold</h3>
//                 <div className={styles.nutriSubHeader}>Per måltid</div>
//                 <div className={styles.nutriChild}>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalKcals} kcal</div>
//                         <div className={styles.nutriS}>Kalorier</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalProtein}g</div>
//                         <div className={styles.nutriS}>Protein</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}> {totalCarbs}g</div>
//                         <div className={styles.nutriS}>Karbo</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalFat}g</div>
//                         <div className={styles.nutriS}>Fett</div>
//                     </div>
//                 </div>
//             </div>
//             <div className={styles.ingredientsContainer}>
//                 <h3>Ingredienser</h3>
//                 {mealInstance.attributes.custom_ingredients.map((ingredient) => (
//                     <div className={styles.ingredientChild} key={ingredient.ingredient_name}>
//                         <div className={styles.ingredientIconContainer}>
//                             <Image fluid alt="nutrients icon" src={IngredientIcon}/>
//                         </div>
//                         <div>{ingredient.ingredient_name}</div>
//                         <div>{ingredient.amount} {ingredient.unit}</div>
//                     </div>
//                 ))}
//             </div>
//             <div className={styles.tabsContainer}>
//                 <div className={styles.customTabs}>
//                     <button className={`${styles.tabButton} ${activeTab === "preparation" ? styles.activeTab : ""}`} onClick={() => setActiveTab("preparation")}>
//                         Prep
//                     </button>
//                     <button className={`${styles.tabButton} ${activeTab === "description" ? styles.activeTab : ""}`} onClick={() => setActiveTab("description")}>
//                         Beskrivelse
//                     </button>
//                     <button className={`${styles.tabButton} ${activeTab === "cookingInstructions" ? styles.activeTab : ""}`} onClick={() => setActiveTab("cookingInstructions")}>
//                         Instruksjoner
//                     </button>
//                 </div>

//                 <div className={styles.tabContent}>
//                     {activeTab === "preparation" && <p>{preparation}</p>}
//                     {activeTab === "description" && <p>{description}</p>}
//                     {activeTab === "cookingInstructions" && <p>{cooking_instructions}</p>}
//                 </div>
//             </div>
//         </div>
//     );
// }

// import React, { useState } from 'react';
// import styles from './styles.module.css';
// import Clock from '../../../../images/icons/timer.png';
// import Chef from '../../../../images/icons/chef-hat.png';
// import Serving from '../../../../images/icons/user (2).png';
// import IngredientIcon from '../../../../images/icons/harvest.png';
// import Image from 'react-bootstrap/Image';

// export default function MealDetail({ mealData, isMealInstance, onBack }) {
//     const mealAttributes = isMealInstance ? mealData.attributes.meal.data.attributes : mealData.attributes;
//     const { name, prep_time, cooking_time, serving, meal_images, category, preparation, description, cooking_instructions } = mealAttributes;
//     const imageUrl = meal_images?.data[0]?.attributes?.image?.data?.attributes?.url;
//     const [activeTab, setActiveTab] = useState("description");
//     console.log(mealData, isMealInstance);

//     const calculateNutrition = () => {
//         let totalProtein = 0;
//         let totalCarbs = 0;
//         let totalFat = 0;
//         let totalKcals = 0;
    
//         const ingredients = isMealInstance
//             ? mealData.attributes.custom_ingredients
//             : mealData.attributes.meal_ingredients.data;
    
//         ingredients.forEach(ingredient => {
//             const amount = isMealInstance
//                 ? parseFloat(ingredient.amount)
//                 : parseFloat(ingredient.attributes.amount); // Henter amount fra riktig sted
    
//             const unit = isMealInstance ? ingredient.unit : ingredient.attributes.unit;
//             const macros = isMealInstance
//                 ? ingredient.macros
//                 : ingredient.attributes.ingredients.data[0].attributes.macros[0]; // Makroer for meal
    
//             if (unit === "stk") {
//                 totalProtein += macros.protein * amount;
//                 totalCarbs += macros.carbs * amount;
//                 totalFat += macros.fat * amount;
//                 totalKcals += macros.kcals * amount;
//             } else if (unit === "g") {
//                 totalProtein += (macros.protein / 100) * amount;
//                 totalCarbs += (macros.carbs / 100) * amount;
//                 totalFat += (macros.fat / 100) * amount;
//                 totalKcals += (macros.kcals / 100) * amount;
//             } else if (unit === "dl") {
//                 const gramsEquivalent = amount * 100;
//                 totalProtein += (macros.protein / 100) * gramsEquivalent;
//                 totalCarbs += (macros.carbs / 100) * gramsEquivalent;
//                 totalFat += (macros.fat / 100) * gramsEquivalent;
//                 totalKcals += (macros.kcals / 100) * gramsEquivalent;
//             }
//         });
    
//         return {
//             totalProtein: Math.round(totalProtein),
//             totalCarbs: Math.round(totalCarbs),
//             totalFat: Math.round(totalFat),
//             totalKcals: Math.round(totalKcals),
//         };
//     };
    
//     const { totalProtein, totalCarbs, totalFat, totalKcals } = calculateNutrition();

//     return (
//         <div className={styles.detailContainer}>
//             <div className={styles.header}>
//                 <button className={styles.backButton} onClick={onBack}>Tilbake</button>
//             </div>
//             <div className={styles.name}>{name}</div>
//             <div className={styles.category}>{category}</div>
//             <div className={styles.mealImage} style={{ backgroundImage: `url(${imageUrl})` }} />
//             <div className={styles.prepInfo}>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Clock} fluid alt="clock icon" />
//                         </div>
//                         <div className={styles.prepText}>Prep:</div>
//                     </div>
//                     <p><strong>{prep_time} min</strong></p>
//                 </div>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Chef} fluid alt="chef icon" />
//                         </div>
//                         <div className={styles.prepText}>Cooking:</div>
//                     </div>
//                     <p><strong>{cooking_time} min</strong></p>
//                 </div>
//                 <div className={styles.prepChild}>
//                     <div className={styles.prepSubHeader}>
//                         <div className={styles.iconContainer}>
//                             <Image src={Serving} fluid alt="servings icon" />
//                         </div>
//                         <div className={styles.prepText}>Serving:</div>
//                     </div>
//                     <p><strong>{serving} serving</strong></p>
//                 </div>
//             </div>
//             <div className={styles.nutritionContainer}>
//                 <h3>Næringsinnhold</h3>
//                 <div className={styles.nutriSubHeader}>Per måltid</div>
//                 <div className={styles.nutriChild}>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalKcals} kcal</div>
//                         <div className={styles.nutriS}>Kalorier</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalProtein}g</div>
//                         <div className={styles.nutriS}>Protein</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}> {totalCarbs}g</div>
//                         <div className={styles.nutriS}>Karbo</div>
//                     </div>
//                     <div className={styles.nutriSub1}>
//                         <div className={styles.nutriP}>{totalFat}g</div>
//                         <div className={styles.nutriS}>Fett</div>
//                     </div>
//                 </div>
//             </div>
//             <div className={styles.ingredientsContainer}>
//             <h3>Ingredienser</h3>
//                 {(isMealInstance ? mealData.attributes.custom_ingredients : mealData.attributes.meal_ingredients.data).map(ingredient => (
//                     <div className={styles.ingredientChild} key={ingredient.ingredient_name || ingredient.id}>
//                         <div className={styles.ingredientIconContainer}>
//                             <Image fluid alt="nutrients icon" src={IngredientIcon} />
//                         </div>
//                         <div>{ingredient.ingredient_name || ingredient.attributes.ingredients.data[0].attributes.name}</div>
//                         <div>{isMealInstance ? ingredient.amount : ingredient.attributes.amount} {isMealInstance ? ingredient.unit : ingredient.attributes.unit}</div>
//                     </div>
//                 ))}
//             </div>
//             <div className={styles.tabsContainer}>
//                 <div className={styles.customTabs}>
//                     <button className={`${styles.tabButton} ${activeTab === "preparation" ? styles.activeTab : ""}`} onClick={() => setActiveTab("preparation")}>
//                         Prep
//                     </button>
//                     <button className={`${styles.tabButton} ${activeTab === "description" ? styles.activeTab : ""}`} onClick={() => setActiveTab("description")}>
//                         Beskrivelse
//                     </button>
//                     <button className={`${styles.tabButton} ${activeTab === "cookingInstructions" ? styles.activeTab : ""}`} onClick={() => setActiveTab("cookingInstructions")}>
//                         Instruksjoner
//                     </button>
//                 </div>

//                 <div className={styles.tabContent}>
//                     {activeTab === "preparation" && <p>{preparation || "Ingen prep tilgjengelig"}</p>}
//                     {activeTab === "description" && <p>{description || "Ingen beskrivelse tilgjengelig"}</p>}
//                     {activeTab === "cookingInstructions" && <p>{cooking_instructions || "Ingen instruksjoner tilgjengelig"}</p>}
//                 </div>
//             </div>
//         </div>
//     );
// }

import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Clock from '../../../../images/icons/timer.png';
import Chef from '../../../../images/icons/chef-hat.png';
import Serving from '../../../../images/icons/user (2).png';
import IngredientIcon from '../../../../images/icons/harvest.png';
import Image from 'react-bootstrap/Image';
import { useParams } from 'react-router';
import { ClientSingleInstance, ClientSingleMeal } from '../../../../hooks/specificMealPage';
import BackButton from '../../../global/backButton';
import fallbackImage from '../../../../images/mat.png';
import { sumNutrition } from '../../../../helpers/nutrition';
//import { ReactComponent as BackIcon } from '../../../../images/icons/back.svg';

export default function MealDetail() {
    const { type, id } = useParams();
    const [mealData, setMealData] = useState(null);
    const [activeTab, setActiveTab] = useState("description");
    const [nutritionView, setNutritionView] = useState("total"); // 'perServing' or 'total'
    const [ingredientView, setIngredientView] = useState("total");

    useEffect(()=> {
        async function fetchMeal() {
            try{
                let response;
                if (type === 'instance') {
                    response = await ClientSingleInstance(id);
                    setMealData({...response, isMealInstance: true});
                } else {
                    response = await ClientSingleMeal(id);
                    setMealData({...response, isMealInstance: false})
                }
            } catch(error) {
                console.error(error);
            }
        };

        fetchMeal();
    },[id, type]);

    if (!mealData) {
        return <div>Laster måltidsinformasjon...</div>;
    }

    const mealAttributes = mealData.isMealInstance ? mealData.attributes.meal.data.attributes : mealData.attributes;

    const descriptionValue = mealData.isMealInstance && mealData.attributes.description 
        ? mealData.attributes.description 
        : mealAttributes.description;

    const { name, prep_time, cooking_time, serving, meal_images, category, preparation, cooking_instructions } = mealAttributes;
    const imageUrl = meal_images?.data[0]?.attributes?.image?.data?.attributes?.url || fallbackImage;

    const calculateNutrition = () => {
        const ingredients = mealData.isMealInstance 
            ? mealData.attributes.custom_ingredients 
            : mealData.attributes.meal_ingredients.data;

        const total = sumNutrition(
            ingredients.map((ingredient) =>
                mealData.isMealInstance
                    ? { macros: ingredient.macros, amount: parseFloat(ingredient.amount), unit: ingredient.unit }
                    : {
                        macros: ingredient.attributes.ingredients.data[0].attributes.macros[0],
                        amount: parseFloat(ingredient.attributes.amount),
                        unit: ingredient.attributes.unit,
                    }
            )
        );

        return {
            totalProtein: total.protein,
            totalCarbs: total.carbs,
            totalFat: total.fat,
            totalKcals: total.kcals,
        };
    };

    const { totalProtein, totalCarbs, totalFat, totalKcals } = calculateNutrition();
    const perServing = Math.max(1, serving);

    const displayedNutrition = nutritionView === "perServing" ? {
        protein: Math.round(totalProtein / perServing),
        carbs: Math.round(totalCarbs / perServing),
        fat: Math.round(totalFat / perServing),
        kcals: Math.round(totalKcals / perServing),
    } : {
        protein: Math.round(totalProtein),
        carbs: Math.round(totalCarbs),
        fat: Math.round(totalFat),
        kcals: Math.round(totalKcals),
    };

    // MED DESIMALER
    // const displayedNutrition = nutritionView === "perServing" ? {
    //     protein: (totalProtein / perServing).toFixed(1), // 1 desimal
    //     carbs: (totalCarbs / perServing).toFixed(1),
    //     fat: (totalFat / perServing).toFixed(1),
    //     kcals: (totalKcals / perServing).toFixed(0), // Ingen desimaler for kalorier
    // } : {
    //     protein: totalProtein.toFixed(1),
    //     carbs: totalCarbs.toFixed(1),
    //     fat: totalFat.toFixed(1),
    //     kcals: totalKcals.toFixed(0),
    // };

    return (
        <div className={`${styles.detailContainer} appearing-container`}>
            <div className="col-12 d-flex d-md-none">
                <div className="col-2 ms-2">
                    <BackButton/>
                </div>
            </div>
            {/* <div className={styles.header}>
                <BackIcon className={styles.backIcon} />
                <button className={styles.backButton} onClick={onBack}>Tilbake</button>
            </div> */}
            <div className={styles.name}>{name}</div>
            <div className={styles.category}>{category}</div>
            <div className={styles.mealImage} style={{ backgroundImage: `url(${imageUrl})` }} />
            <div className={styles.prepInfo}>
                <div className={styles.prepChild}>
                    <div className={styles.prepSubHeader}>
                        <div className={styles.iconContainer}>
                            <Image src={Clock} fluid alt="clock icon" />
                        </div>
                        <div className={styles.prepText}>Prep:</div>
                    </div>
                    <p><strong>{prep_time} min</strong></p>
                </div>
                <div className={styles.prepChild}>
                    <div className={styles.prepSubHeader}>
                        <div className={styles.iconContainer}>
                            <Image src={Chef} fluid alt="chef icon" />
                        </div>
                        <div className={styles.prepText}>Cooking:</div>
                    </div>
                    <p><strong>{cooking_time} min</strong></p>
                </div>
                <div className={styles.prepChild}>
                    <div className={styles.prepSubHeader}>
                        <div className={styles.iconContainer}>
                            <Image src={Serving} fluid alt="servings icon" />
                        </div>
                        <div className={styles.prepText}>Serving:</div>
                    </div>
                    <p><strong>{serving} serving</strong></p>
                </div>
            </div>
            {/* <div className={styles.nutritionContainer}>
                <h3>Næringsinnhold</h3>
                <div className={styles.nutriSubHeader}>Per måltid</div>
                <div className={styles.nutriChild}>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{totalKcals} kcal</div>
                        <div className={styles.nutriS}>Kalorier</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{totalProtein}g</div>
                        <div className={styles.nutriS}>Protein</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{totalCarbs}g</div>
                        <div className={styles.nutriS}>Karbo</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{totalFat}g</div>
                        <div className={styles.nutriS}>Fett</div>
                    </div>
                </div>
            </div> */}
            <div className={styles.nutritionContainer}>
                <h3>Næringsinnhold</h3>
                {serving > 1 && (
                    <div className={styles.customTabs}>
                        <button className={`${styles.tabButton} ${nutritionView === "perServing" ? styles.activeTab : ""}`}
                            onClick={() => setNutritionView("perServing")}>
                            Per porsjon
                        </button>
                        <button className={`${styles.tabButton} ${nutritionView === "total" ? styles.activeTab : ""}`}
                            onClick={() => setNutritionView("total")}>
                            Totalt
                        </button>
                    </div>
                )}
                <div className={styles.nutriChild}>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{displayedNutrition.kcals} kcal</div>
                        <div className={styles.nutriS}>Kalorier</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{displayedNutrition.protein}g</div>
                        <div className={styles.nutriS}>Protein</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{displayedNutrition.carbs}g</div>
                        <div className={styles.nutriS}>Karbo</div>
                    </div>
                    <div className={styles.nutriSub1}>
                        <div className={styles.nutriP}>{displayedNutrition.fat}g</div>
                        <div className={styles.nutriS}>Fett</div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.ingredientsContainer}>
                <h3>Ingredienser</h3>
                {(mealData.isMealInstance ? mealData.attributes.custom_ingredients : mealData.attributes.meal_ingredients.data).map(ingredient => (
                    <div className={styles.ingredientChild} key={ingredient.ingredient_name || ingredient.id}>
                        <div className={styles.ingredientIconContainer}>
                            <Image fluid alt="nutrients icon" src={IngredientIcon} />
                        </div>
                        <div>{ingredient.ingredient_name || ingredient.attributes.ingredients.data[0].attributes.name}</div>
                        <div>{mealData.isMealInstance ? ingredient.amount : ingredient.attributes.amount} {mealData.isMealInstance ? ingredient.unit : ingredient.attributes.unit}</div>
                    </div>
                ))}
            </div> */}
            <div className={styles.ingredientsContainer}>
                <h3>Ingredienser</h3>
                {serving > 1 && (
                    <div className={styles.customTabs}>
                        <button className={`${styles.tabButton} ${ingredientView === "perServing" ? styles.activeTab : ""}`}
                            onClick={() => setIngredientView("perServing")}>
                            Per porsjon
                        </button>
                        <button className={`${styles.tabButton} ${ingredientView === "total" ? styles.activeTab : ""}`}
                            onClick={() => setIngredientView("total")}>
                            Totalt
                        </button>
                    </div>
                )}
                {(mealData.isMealInstance ? mealData.attributes.custom_ingredients : mealData.attributes.meal_ingredients.data).map(ingredient => {
                    const amount = ingredientView === "perServing"
                        ? (ingredient.amount || ingredient.attributes.amount) / perServing
                        : (ingredient.amount || ingredient.attributes.amount);
                        //MED DESIMALER
                        // const formattedAmount = amount.toFixed(2);

                    return (
                        <div className={styles.ingredientChild} key={ingredient.ingredient_name || ingredient.id}>
                            <div className={styles.ingredientIconContainer}>
                                <Image fluid alt="nutrients icon" src={IngredientIcon} />
                            </div>
                            <div>{ingredient.ingredient_name || ingredient.attributes.ingredients.data[0].attributes.name}</div>
                            <div>{amount} {ingredient.unit || ingredient.attributes.unit}</div>
                        </div>
                    );
                })}
            </div>
            <div className={styles.tabsContainer}>
                <div className={styles.customTabs}>
                    <button className={`${styles.tabButton} ${activeTab === "preparation" ? styles.activeTab : ""}`} onClick={() => setActiveTab("preparation")}>
                        Prep
                    </button>
                    <button className={`${styles.tabButton} ${activeTab === "description" ? styles.activeTab : ""}`} onClick={() => setActiveTab("description")}>
                        Beskrivelse
                    </button>
                    <button className={`${styles.tabButton} ${activeTab === "cookingInstructions" ? styles.activeTab : ""}`} onClick={() => setActiveTab("cookingInstructions")}>
                        Instruksjoner
                    </button>
                </div>

                <div className={styles.tabContent}>
                    {activeTab === "preparation" && <p>{preparation || "Ingen prep tilgjengelig"}</p>}
                    {activeTab === "description" && <p>{descriptionValue || "Ingen beskrivelse tilgjengelig"}</p>}
                    {activeTab === "cookingInstructions" && <p>{cooking_instructions || "Ingen instruksjoner tilgjengelig"}</p>}
                </div>
            </div>
        </div>
    );
}
